/** Hands a blob to the browser as a file save, revoking the object URL afterwards. */
export const triggerBrowserDownload = (blob: Blob, filename: string): void => {
  const objectUrl = URL.createObjectURL(blob);

  try {
    downloadFromUrl(objectUrl, filename);
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
};

/**
 * Navigates to `url` as a file save. `filename` is ignored by the browser for
 * cross-origin URLs, where the response's `Content-Disposition` names the file.
 */
export const downloadFromUrl = (url: string, filename?: string): void => {
  const anchor = document.createElement("a");
  anchor.href = url;
  if (filename !== undefined) anchor.download = filename;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};
